import { render } from "./RelationshipTable.vue?vue&type=template&id=fa259e4c"
import script from "./RelationshipTable.vue?vue&type=script&lang=js"
export * from "./RelationshipTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__